import React from 'react';
import ProjectNew from '../components/project/ProjectNew';

export default function NewProject() {
  return (
    <React.Fragment>
      <div className='main-panel'>
        <div className='content'>
          <ProjectNew />
        </div>
      </div>
    </React.Fragment>
  );
}
